import { supabase } from "@/lib/supabase";

const sb = supabase as any;

export type EngagementSummary = {
  last_active_at: string | null;
  session_count: number;
  total_voice_seconds: number;
  resource_views: number;
  resource_completes: number;
  consent_state: "none" | "active" | "withdrawn";
};

export type EngagementTimelineItem = {
  created_at: string;
  event_type: string;
  resource_id: string | null;
  resource_title: string | null;
  metadata: Record<string, unknown>;
};

export type Engagement = {
  site: {
    id: string;
    title: string | null;
    user_id: string;
    coach_user_id: string | null;
    status: string;
  };
  summary: EngagementSummary;
  timeline: EngagementTimelineItem[];
};

export async function getEngagement(siteId: string): Promise<Engagement> {
  const { data, error } = await sb.rpc("admin_get_concierge_engagement", { _site_id: siteId });
  if (error) throw error;
  return data as Engagement;
}

export type CoachOption = { user_id: string; handle: string };

export async function listCoaches(orgId: string): Promise<CoachOption[]> {
  const { data, error } = await sb.rpc("admin_list_concierge_org_coaches", { _org_id: orgId });
  if (error) throw error;
  return (data ?? []) as CoachOption[];
}

function randomToken(): string {
  const bytes = new Uint8Array(32);
  crypto.getRandomValues(bytes);
  return btoa(String.fromCharCode(...bytes))
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
}

export async function createInvite(input: {
  site_id: string;
  org_id: string;
  email: string;
}): Promise<{ token: string; link: string }> {
  const { data: userData } = await supabase.auth.getUser();
  const uid = userData.user?.id;
  if (!uid) throw new Error("not_authenticated");
  const token = randomToken();
  const { error } = await sb.from("concierge_invites").insert({
    site_id: input.site_id,
    org_id: input.org_id,
    email: input.email.trim().toLowerCase(),
    token,
    created_by: uid,
  });
  if (error) throw error;
  const link = `${window.location.origin}/auth/signup?concierge_invite=${token}`;
  return { token, link };
}
